<div
  class="flex h-full w-full overflow-hidden rounded-md border bg-surface text-xs text-color"
  [class]="frameClass()"
  [attr.title]="tooltip()"
>
  <div class="min-w-1" [class]="barClass()" data-testid="roster-card-bar">&nbsp;</div>
  <div
    class="flex h-full min-w-0 w-full flex-col"
    [class]="headerClass()"
    [class.pb-1]="!timeLabel()"
    data-testid="roster-card-body"
  >
    <div
      class="flex items-center gap-1 p-1 font-semibold"
      data-testid="roster-card-header"
    >
      <span
        class="min-w-0 flex-1 truncate"
        [class.italic]="titleItalic()"
        data-testid="roster-card-title"
      >
        {{ title() }}
      </span>
      <span class="flex shrink-0 items-center gap-1">
        <ng-content select="[rosterCardActions]" />
        <ng-content select="[rosterCardBadge]" />
        @if (icon(); as iconName) {
          <soft-icon
            [class]="iconClass()"
            [name]="iconName"
            data-testid="roster-card-icon"
          />
        }
      </span>
    </div>

    @if (subtitle(); as text) {
      <p class="truncate px-1">{{ text }}</p>
    }

    @if (!compact() && description(); as html) {
      <span class="px-1" [innerHTML]="html"></span>
    }

    @if (!compact()) {
      <ng-content select="[rosterCardDetails]" />
    }

    @if (timeLabel(); as time) {
      <div
        class="flex justify-between px-1 pb-1"
        [class]="compact() ? 'overflow-hidden whitespace-nowrap' : 'pt-1'"
      >
        <p class="font-semibold">{{ time }}</p>
        <span class="flex-1"></span>
        <ng-content select="[rosterCardMeta]" />
        @if (durationLabel(); as duration) {
          <p class="pl-1 text-light">{{ duration }}</p>
        }
      </div>
    }
  </div>
</div>
